import { useEffect } from 'react';
import { useFragment, graphql } from 'react-relay';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useEuEligible } from './useEuEligible';

import type { useTrackExposedReturns_viewer$key } from './__generated__/useTrackExposedReturns_viewer.graphql';

const viewerFragment = graphql`
    fragment useTrackExposedReturns_viewer on Viewer {
        ...useEuEligible_viewer @arguments(userCountryCode: $userCountryCode)
    }
`;

export const useTrackExposedReturns = ({
    viewer: viewerRef,
}: {
    viewer?: useTrackExposedReturns_viewer$key | null;
}): void => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const isEuEligible = useEuEligible({ viewer });

    useEffect(() => {
        if (isEuEligible) {
            trackAbTestV2Variant('ReturnsonPDP');
        }
    }, [isEuEligible]);
};
